import { useStyles } from './sectionFaq.jss';
import { Box, Button, Container } from '@material-ui/core';
import React, { useState } from 'react';
import Paragraph from '../../components/paragraph/paragraph';
import SectionAccordion from '../section-accordion/sectionAccordion';
import SectionFaqSteps from '../section-faq-steps/sectionFaqSteps';

const SectionFaq = ({
  translations: { collapseBox, expandBox, accordionTitle, accordionData, steps }
}) => {
  const [expanded, setExpanded] = useState(false);
  const classes = useStyles();

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Box className={classes.btnBox}>
        <Paragraph variant="h4" className={classes.paragraph}>
          {expanded ? expandBox.desc : collapseBox.desc}
        </Paragraph>
        <Button className={classes.faqButton} onClick={handleChange}>
          {expanded ? expandBox.button : collapseBox.button}
        </Button>
      </Box>
      {expanded && (
        <>
          {process.env.REACT_APP_BRAND === 'dacia' ? <SectionFaqSteps steps={steps} /> : null}
          <SectionAccordion content={accordionData} title={accordionTitle} />
        </>
      )}
    </Container>
  );
};

export default SectionFaq;
